"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _core = require("@material-ui/core");

var _Typography2 = _interopRequireDefault(require("./Typography.css"));

var Typography =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Typography, _React$PureComponent);

  function Typography() {
    (0, _classCallCheck2.default)(this, Typography);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Typography).apply(this, arguments));
  }

  (0, _createClass2.default)(Typography, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          align = _this$props.align,
          className = _this$props.className,
          color = _this$props.color,
          component = _this$props.component,
          display = _this$props.display,
          fullHeight = _this$props.fullHeight,
          fullWidth = _this$props.fullWidth,
          noWrap = _this$props.noWrap,
          variant = _this$props.variant,
          classes = _this$props.classes;

      if (!children && children !== 0) {
        return null;
      } // Cannot use classes because of the hack provided in Typography.css.js.


      var fullStyles = {
        width: {
          width: '100%'
        },
        height: {
          height: '100%'
        }
      };
      return React.createElement(_Typography.default, {
        align: align,
        className: "".concat(classes[variant], " ").concat(className ? className : ''),
        color: color,
        component: component,
        display: display,
        noWrap: noWrap,
        style: (0, _objectSpread2.default)({}, fullWidth ? fullStyles.width : {}, fullHeight ? fullStyles.height : {})
      }, children);
    }
  }]);
  return Typography;
}(React.PureComponent);

Typography.defaultProps = {
  align: 'inherit',
  color: 'initial',
  component: 'div',
  display: 'initial',
  fullHeight: false,
  fullWidth: false,
  noWrap: false,
  variant: 'body2'
};
Typography.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Set the text-align on the component.
   */
  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * A class name that can be applied.
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component of the Typography.
   * Defaults to p if children is a string, div otherwise.
   */
  component: _propTypes.default.string,

  /**
   * Controls the display type of the Typography element.
   */
  display: _propTypes.default.oneOf(['initial', 'block', 'inline']),

  /**
   * Whether the Typography is full height or not.
   * Defaults to false.
   * Should only really be used in dire circumstances.
   */
  fullHeight: _propTypes.default.bool,

  /**
   * Whether the Typography is full width or not.
   * Defaults to false.
   * Should only really be used in dire circumstances.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Whether the Typography does not wrap or wraps.
   */
  noWrap: _propTypes.default.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'button2', 'overline', 'error', 'textField', 'dialogHeader', 'dialogContent', 'drawerTitle', 'dropdown', 'dateDisplay', 'inherit'])
};

var _default = (0, _core.withStyles)(_Typography2.default)(Typography);

exports.default = _default;